(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["activity-hero-aquas"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var ctaLink = document.querySelector('.activity-hero__cta-link');
    if (!ctaLink) return;

    ctaLink.addEventListener('click', function (e) {
      e.preventDefault();
      var targetKey = this.dataset.anchor;
      if (!targetKey) return;

      var target = document.querySelector('[id$="__' + targetKey + '"]');
      if (target) {
        var headerOffset = 80;
        var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-aquas"]) return;
  try {
    
  // Mobile drawer toggle
  (function () {
    const toggle = document.querySelector('.header-mobile-toggle');
    const drawer = document.querySelector('.mobile-drawer');
    const overlay = document.querySelector('.mobile-drawer__overlay');
    const closeBtn = document.querySelector('.mobile-drawer__close');

    if (!toggle || !drawer) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('drawer-open');
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('drawer-open');
    }

    toggle.addEventListener('click', openDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    // Close on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });
  })();

  // Update header cart total on cart changes
  (function () {
    const cartTotal = document.getElementById('cart-total-price');
    if (!cartTotal || typeof subscribe === 'undefined') return;

    const format = cartTotal.dataset.moneyFormat || '';

    function formatMoney(cents) {
      const amount = (cents / 100).toFixed(2);
      const parts = amount.split('.');
      const whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return format
        .replace('{{amount_with_comma_separator}}', whole + ',' + parts[1])
        .replace('{{amount}}', amount)
        .replace('{{amount_no_decimals}}', Math.round(cents / 100).toString())
        .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
        .replace('{{amount_with_apostrophe_separator}}', parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'") + '.' + parts[1]);
    }

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event.cartData && typeof event.cartData.total_price === 'number') {
        cartTotal.textContent = formatMoney(event.cartData.total_price);
      }
    });
  })();

  // Sticky header behavior
  (function () {
    const header = document.querySelector('.aquas-header[data-sticky="compact"]');
    if (!header) return;

    let lastScroll = 0;
    const scrollThreshold = 100;

    window.addEventListener(
      'scroll',
      () => {
        const currentScroll = window.pageYOffset;

        if (currentScroll > scrollThreshold) {
          header.classList.add('scrolled');
        } else {
          header.classList.remove('scrolled');
        }

        lastScroll = currentScroll;
      },
      { passive: true }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-aquas"] && !Shopify.designMode) return;
  try {
    
  class AquasHeroSlider extends HTMLElement {
    constructor() {
      super();
      this.currentSlide = 0;
      this.slides = this.querySelectorAll('.hero__slide');
      this.dots = this.querySelectorAll('.hero__dot');
      this.autoRotate = this.dataset.autoRotate === 'true';
      this.rotateSpeed = parseInt(this.dataset.rotateSpeed) || 5000;
      this.intervalId = null;

      this.init();
    }

    init() {
      // Add click handlers to dots
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          this.goToSlide(index);
          this.resetAutoRotate();
        });
      });

      // Start auto-rotate if enabled
      if (this.autoRotate && this.slides.length > 1) {
        this.startAutoRotate();

        // Pause on hover
        this.addEventListener('mouseenter', () => this.stopAutoRotate());
        this.addEventListener('mouseleave', () => this.startAutoRotate());
      }
    }

    goToSlide(index) {
      // Remove active class from current slide and dot
      this.slides[this.currentSlide].classList.remove('hero__slide--active');
      if (this.dots[this.currentSlide]) {
        this.dots[this.currentSlide].classList.remove('hero__dot--active');
      }

      // Set new current slide
      this.currentSlide = index;

      // Add active class to new slide and dot
      this.slides[this.currentSlide].classList.add('hero__slide--active');
      if (this.dots[this.currentSlide]) {
        this.dots[this.currentSlide].classList.add('hero__dot--active');
      }
    }

    nextSlide() {
      const nextIndex = (this.currentSlide + 1) % this.slides.length;
      this.goToSlide(nextIndex);
    }

    startAutoRotate() {
      if (this.intervalId) return;
      this.intervalId = setInterval(() => this.nextSlide(), this.rotateSpeed);
    }

    stopAutoRotate() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }

    resetAutoRotate() {
      this.stopAutoRotate();
      if (this.autoRotate) {
        this.startAutoRotate();
      }
    }

    disconnectedCallback() {
      this.stopAutoRotate();
    }
  }

  customElements.define('aquas-hero-slider', AquasHeroSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["intent-router-aquas"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('.intent-router');
    if (!section) return;

    section.addEventListener('click', function (e) {
      var card = e.target.closest('[data-intent-anchor]');
      if (card) {
        e.preventDefault();
        var key = card.getAttribute('data-intent-anchor');
        var target = document.querySelector('[id$="__' + key + '"]');
        if (target) {
          var rect = target.getBoundingClientRect();
          var offset = 80;
          window.scrollTo({
            top: window.scrollY + rect.top - offset,
            behavior: 'smooth',
          });
        }
        return;
      }

      var searchCard = e.target.closest('[data-intent-search]');
      if (searchCard) {
        e.preventDefault();
        var selectors = [
          '[data-search-toggle]',
          '.header__search-button',
          'details-modal .header__icon--search',
          '.header-aquas__search-toggle',
        ];
        for (var i = 0; i < selectors.length; i++) {
          var btn = document.querySelector(selectors[i]);
          if (btn) {
            btn.click();
            return;
          }
        }
        window.location.href = '/search';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article-aquas"]) return;
  try {
    
  /* Auto-generate Table of Contents from article headings */
  (function() {
    var tocNav = document.getElementById('blog-toc-nav');
    if (!tocNav) return;

    var content = document.querySelector('.blog-article__content');
    if (!content) return;

    var headings = content.querySelectorAll('h2, h3');
    if (headings.length === 0) {
      var tocContainer = document.getElementById('blog-toc');
      if (tocContainer) tocContainer.style.display = 'none';
      return;
    }

    headings.forEach(function(heading, index) {
      var id = heading.id || 'section-' + index;
      heading.id = id;

      var link = document.createElement('a');
      link.href = '#' + id;
      link.className = 'blog-toc__link';
      if (heading.tagName === 'H3') {
        link.style.paddingLeft = '24px';
      }
      link.textContent = heading.textContent;
      tocNav.appendChild(link);

      link.addEventListener('click', function(e) {
        e.preventDefault();
        var target = document.getElementById(id);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  })();

  /* Wrap tables in scrollable container */
  document.querySelectorAll('.blog-article__content table').forEach(function(table) {
    if (table.parentElement.classList.contains('table-wrapper')) return;
    var wrapper = document.createElement('div');
    wrapper.className = 'table-wrapper';
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  });

  /* FAQ Accordion */
  document.querySelectorAll('.faq-item').forEach(function(item) {
    var question = item.querySelector('.faq-question');
    if (!question) return;
    question.addEventListener('click', function() {
      var isOpen = item.classList.contains('faq-item--open');
      document.querySelectorAll('.faq-item').forEach(function(other) {
        other.classList.remove('faq-item--open');
      });
      if (!isOpen) {
        item.classList.add('faq-item--open');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-faq-aquas"]) return;
  try {
    
  (function () {
    var faqPage = document.querySelector('.faq-page');
    if (!faqPage) return;

    var headings = faqPage.querySelectorAll('h3');
    var converted = 0;

    headings.forEach(function (h3) {
      var qText = h3.textContent.trim();
      if (!qText || qText.indexOf('?') === -1) return;

      var answerNodes = [];
      var next = h3.nextElementSibling;
      while (next && ['H3', 'H2', 'HR'].indexOf(next.tagName) === -1) {
        answerNodes.push(next);
        next = next.nextElementSibling;
      }

      if (answerNodes.length === 0) return;

      var details = document.createElement('details');
      details.className = 'faq-accordion';
      details.setAttribute('open', '');

      var summary = document.createElement('summary');
      summary.className = 'faq-accordion__question';
      summary.textContent = qText;
      details.appendChild(summary);

      var answerDiv = document.createElement('div');
      answerDiv.className = 'faq-accordion__answer rte';
      answerNodes.forEach(function (node) {
        answerDiv.appendChild(node);
      });
      details.appendChild(answerDiv);

      h3.parentNode.replaceChild(details, h3);
      converted++;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-videos-aquas"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function switchVideo(thumb, autoplay) {
      var sectionId = thumb.dataset.sectionId;
      var videoId = thumb.dataset.videoId;
      var videoTitle = thumb.dataset.videoTitle;
      var videoDescription = thumb.dataset.videoDescription;

      var mainVideo = document.getElementById('mainVideo-' + sectionId);
      if (mainVideo) {
        var src = 'https://www.youtube-nocookie.com/embed/' + videoId + '?rel=0';
        if (autoplay) src += '&autoplay=1';
        mainVideo.src = src;
        mainVideo.title = videoTitle;
      }

      var titleEl = document.getElementById('videoTitle-' + sectionId);
      var descEl = document.getElementById('videoDescription-' + sectionId);

      if (titleEl) titleEl.textContent = videoTitle;
      if (descEl) {
        if (videoDescription) {
          descEl.textContent = videoDescription;
          descEl.style.display = 'block';
        } else {
          descEl.style.display = 'none';
        }
      }

      var container = thumb.closest('.product-videos__thumbnails');
      if (container) {
        container.querySelectorAll('.product-videos__thumb').forEach(function (t) {
          t.classList.remove('product-videos__thumb--active');
          t.setAttribute('aria-pressed', 'false');
        });
        thumb.classList.add('product-videos__thumb--active');
        thumb.setAttribute('aria-pressed', 'true');
      }
    }

    document.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-video-switch]');
      if (!thumb) return;
      switchVideo(thumb, true);
    });

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.product-videos__thumbnails').forEach(function (container) {
        var firstThumb = container.querySelector('.product-videos__thumb');
        if (firstThumb) switchVideo(firstThumb, false);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-aquas"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const STORAGE_KEY = 'aquas_recently_viewed';
    const MAX_PRODUCTS = 20;

    function getRecentlyViewed() {
      try {
        const data = localStorage.getItem(STORAGE_KEY);
        return data ? JSON.parse(data) : [];
      } catch (e) {
        return [];
      }
    }

    function saveToRecentlyViewed(handle) {
      if (!handle) return;

      let products = getRecentlyViewed();
      products = products.filter((h) => h !== handle);
      products.unshift(handle);
      products = products.slice(0, MAX_PRODUCTS);

      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(products));
      } catch (e) {
        console.error('Failed to save recently viewed:', e);
      }
    }

    function formatMoney(cents) {
      const amount = (cents / 100).toFixed(2);
      return amount.replace('.', ',') + ' \u20AC';
    }

    async function fetchProduct(handle) {
      try {
        const response = await fetch('/products/' + handle + '.js');
        if (!response.ok) throw new Error('Product not found');
        return await response.json();
      } catch (e) {
        return null;
      }
    }

    async function renderRecentlyViewed(section) {
      const sectionId = section.dataset.sectionId;
      const productsToShow = parseInt(section.dataset.productsToShow) || 4;
      const grid = document.getElementById('recently-viewed-grid-' + sectionId);
      const template = document.getElementById('recently-viewed-template-' + sectionId);

      if (!grid || !template) return;

      let handles = getRecentlyViewed();

      const currentHandle = window.location.pathname.split('/products/')[1];
      if (currentHandle) {
        handles = handles.filter((h) => h !== currentHandle.split('?')[0]);
      }

      handles = handles.slice(0, productsToShow);

      if (handles.length === 0) {
        section.style.display = 'none';
        return;
      }

      section.style.display = 'block';
      section.classList.add('recently-viewed--loading');
      grid.innerHTML = '<div class="recently-viewed__loader"></div>';

      const products = await Promise.all(handles.map(fetchProduct));
      const validProducts = products.filter((p) => p !== null);

      if (validProducts.length === 0) {
        section.style.display = 'none';
        return;
      }

      section.classList.remove('recently-viewed--loading');
      grid.innerHTML = '';

      validProducts.forEach(function (product) {
        const card = template.content.cloneNode(true);
        const urlEl = card.querySelector('[data-url]');

        if (urlEl) {
          urlEl.href = '/products/' + product.handle;
        }

        // Image
        const img = card.querySelector('[data-img]');
        if (product.featured_image) {
          img.src = product.featured_image.replace(/\.([^.]+)$/, '_600x600_crop_center.$1');
          img.alt = product.title;
        }

        // Badge - sale detection
        const badge = card.querySelector('[data-badge]');
        if (product.compare_at_price && product.compare_at_price > product.price) {
          const discount = Math.round(((product.compare_at_price - product.price) / product.compare_at_price) * 100);
          badge.textContent = '-' + discount + '%';
          badge.classList.add('product-card__badge--sale');
          badge.style.display = '';
        }

        // Vendor
        const vendor = card.querySelector('[data-vendor]');
        if (vendor && product.vendor) {
          vendor.textContent = product.vendor.toUpperCase();
        }

        // Title
        const title = card.querySelector('[data-title]');
        if (title) {
          title.textContent = product.title;
        }

        // Price
        const priceWrap = card.querySelector('[data-price-wrap]');
        if (priceWrap) {
          if (product.compare_at_price && product.compare_at_price > product.price) {
            priceWrap.innerHTML =
              '<span class="product-card__price-original">' +
              formatMoney(product.compare_at_price) +
              '</span>' +
              '<span class="product-card__price-sale">' +
              formatMoney(product.price) +
              '</span>';
          } else {
            priceWrap.innerHTML = '<span class="product-card__price-regular">' + formatMoney(product.price) + '</span>';
          }
        }

        // Quick add
        const quickAdd = card.querySelector('[data-quick-add]');
        if (quickAdd) {
          const variantId = product.variants && product.variants[0] ? product.variants[0].id : null;
          if (variantId) {
            quickAdd.dataset.productId = product.id;
            quickAdd.dataset.variantId = variantId;
          }
          if (!product.available) {
            quickAdd.disabled = true;
            quickAdd.classList.add('product-card__quick-add--disabled');
            quickAdd.textContent =
              quickAdd.closest('section').querySelector('[data-sold-out-text]')?.textContent || 'Razprodano';
          }
        }

        // Wishlist
        const wishlist = card.querySelector('[data-wishlist]');
        if (wishlist) {
          wishlist.dataset.productId = product.id;
        }

        grid.appendChild(card);
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      const productData = document.querySelector('[data-product-json]');
      if (productData) {
        try {
          const product = JSON.parse(productData.textContent);
          if (product.handle) {
            saveToRecentlyViewed(product.handle);
          }
        } catch (e) {}
      }

      const urlMatch = window.location.pathname.match(/\/products\/([^/?]+)/);
      if (urlMatch && urlMatch[1]) {
        saveToRecentlyViewed(urlMatch[1]);
      }

      document.querySelectorAll('[data-recently-viewed]').forEach(renderRecentlyViewed);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seo-content-aquas"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const toggleButtons = document.querySelectorAll('.seo-content__toggle');

    toggleButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        const content = this.previousElementSibling;
        const isCollapsed = content.dataset.collapsed === 'true';

        content.dataset.collapsed = isCollapsed ? 'false' : 'true';
        this.textContent = isCollapsed ? this.dataset.collapseText : this.dataset.expandText;
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
